<mat-card style="height: 100%">
    <mat-card-content style="display: flex; flex-direction: column">
        <div class="titleTabContent" style="justify-content: flex-start" *ngIf="false">
            <ms-software-upgrade-scheduling></ms-software-upgrade-scheduling>
            <mat-divider></mat-divider>
        </div>

        <div class="titleTabContent email-title-alignment">
            <span translate>EMAIL_SECTION</span>
        </div>

        <div *ngIf="showEmailSection">
            <div>
                <p>{{ subtitle_1 }}</p>
                <p *ngIf="productID != 'MW'">{{ subtitle_2 }}</p>
            </div>
            <div style="margin: 2rem; margin-left: 0rem">
                <div *ngIf="!showEdit">
                    <h4><span translate>COMMONS.CURRENTLY_VALIDATED_EMAIL</span>:</h4>
                    <div style="display: flex">
                        <div style="margin-top: 0.6rem">
                            <span class="text-bold">{{ emailEntity.Email }}</span>
                        </div>
                        <span
                            *ngIf="emailEntity.EmailValidated"
                            class="material-icons"
                            style="color: green"
                            matTooltip="{{ 'M_SUB_MNG_TOOLTIP_3' | translate }}"
                            matTooltipClass="tooltip-layout"
                        >
                            verified
                        </span>
                        <div>
                            <button mat-button color="primary" (click)="modifyContent(true)">
                                <span translate>COMMONS.CHANGE</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div *ngIf="showEdit">
                    <div *ngIf="subscription.IsOnPrem; else isNotOnPrem">
                        <h4><span translate>COMMONS.COMPANY_EMAIL</span>:</h4>
                    </div>
                    <ng-template #isNotOnPrem>
                        <h4><span translate>COMMONS.EMAIL_TO_VALIDATE</span>:</h4>
                    </ng-template>
                    <div style="display: flex">
                        <div style="margin-top: 0.6rem; flex-grow: 4">
                            <mat-form-field appearance="outline" style="min-width: 3rem">
                                <mat-label translate>SENDER_EMAIL</mat-label>
                                <input
                                    matInput
                                    [formControl]="emailControl"
                                    [(ngModel)]="emailEntity.Email"
                                    (ngModelChange)="emailParamsChanged()"
                                    name="OfficialEmail"
                                    required
                                />
                                <mat-hint *ngIf="emailControl.invalid"
                                    ><span class="mandatory">{{ getErrorMessage() }}</span></mat-hint
                                >
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
            <div style="display: flex; justify-content: space-between; margin: 2rem; margin-left: 0rem; margin-top: 0rem; flex-wrap: wrap">
                <div style="margin-bottom: 1rem">
                    <div class="flex-row">
                        <mat-slide-toggle
                            (ngModelChange)="setEmails($event, 'cc')"
                            [(ngModel)]="ccEmail"
                            [checked]="ccEmailChecked"
                            name="ccEmail"
                        >
                            <span translate>CC_EMAIL</span>
                        </mat-slide-toggle>
                    </div>
                    <div class="flex-row align-center" *ngIf="ccEmailChecked">
                        <mat-form-field appearance="outline">
                            <mat-label translate>L_CC_EMAIL</mat-label>
                            <input
                                matInput
                                [formControl]="ccEmailControl"
                                [(ngModel)]="emailEntity.Cc"
                                (ngModelChange)="emailParamsChanged()"
                                name="inputCCEmail"
                            />
                            <mat-error *ngIf="ccEmailControl.invalid">{{ getErrorMessage() }} </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div>
                    <div class="flex-row">
                        <mat-slide-toggle
                            (ngModelChange)="setEmails($event, 'bcc')"
                            [(ngModel)]="bccEmail"
                            [checked]="bccEmailChecked"
                            name="bccEmail"
                        >
                            <span translate>BCC_EMAIL</span>
                        </mat-slide-toggle>

                        <span
                            *ngIf="false"
                            class="material-icons"
                            style="margin-left: 10px"
                            matTooltip="{{ '' | translate }}"
                            matTooltipClass="tooltip-layout"
                            >help</span
                        >
                    </div>

                    <div class="flex-row align-center" *ngIf="bccEmailChecked">
                        <mat-form-field appearance="outline">
                            <mat-label translate>L_BCC_EMAIL</mat-label>
                            <input
                                matInput
                                [formControl]="bccEmailControl"
                                [(ngModel)]="emailEntity.Bcc"
                                name="inputBCCEmail"
                                (ngModelChange)="emailParamsChanged()"
                            />
                            <mat-error *ngIf="bccEmailControl.invalid">{{ getErrorMessage() }} </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>

        <p *ngIf="!showEmailSection">{{ advancedSettingsSubtitle }}</p>

        <div *ngIf="this.productID != 'MW' && showAdvancedSettings">
            <mat-divider *ngIf="showEmailSection"></mat-divider>
            <p class="titleTabContent mt-2" style="justify-content: flex-start" translate>ADV_SETTINGS</p>
            <div style="display: flex; flex-direction: column">
                <div style="display: flex" *ngIf="existsAuditing">
                    <div class="content-padding-03">
                        <mat-slide-toggle
                            (ngModelChange)="setAdvancedSettings($event, 'AUDITING')"
                            [(ngModel)]="advancedSettings.CheckedAuditing"
                            name="AuditingMode"
                        >
                        </mat-slide-toggle>
                    </div>
                    <div class="content-padding-03">
                        <span translate class="text-bold">EDIT_SUBSCRIPTION.ENABLEAUDITING</span>&nbsp;-&nbsp;
                        <span>{{ 'EDIT_SUBSCRIPTION.ENABLEAUDITING_TOOLTIP_1' | translate }}</span>
                    </div>
                </div>
                <div style="display: flex" *ngIf="existsVisibility">
                    <div class="content-padding-03">
                        <mat-slide-toggle
                            (ngModelChange)="setAdvancedSettings($event, 'VISIBILITY')"
                            [(ngModel)]="advancedSettings.CheckedVisibility"
                            name="Visibility"
                        >
                        </mat-slide-toggle>
                    </div>
                    <div class="content-padding-03">
                        <span translate class="text-bold">EDIT_SUBSCRIPTION.VISIBILITY</span>&nbsp;-&nbsp;
                        <span>{{ 'EDIT_SUBSCRIPTION.VISIBILITY_TOOLTIP_1' | translate }}</span>
                    </div>
                </div>
                <div style="display: flex" *ngIf="existsSecurity">
                    <div class="content-padding-03">
                        <mat-slide-toggle
                            (ngModelChange)="setAdvancedSettings($event, 'SECURITY')"
                            [(ngModel)]="advancedSettings.CheckedSecurity"
                            name="Security"
                        >
                        </mat-slide-toggle>
                    </div>
                    <div class="content-padding-03">
                        <span translate class="text-bold">EDIT_SUBSCRIPTION.SECURITY</span>&nbsp;-&nbsp;
                        <span>{{ 'EDIT_SUBSCRIPTION.SECURITY_TOOLTIP_1' | translate }} </span>
                    </div>
                </div>

                <div style="display: flex" *ngIf="existsCGM">
                    <div class="content-padding-03">
                        <mat-slide-toggle
                            (ngModelChange)="setAdvancedSettings($event, 'CGM')"
                            [(ngModel)]="advancedSettings.CheckedCGM"
                            name="CGM"
                        >
                        </mat-slide-toggle>
                    </div>

                    <div class="content-padding-03">
                        <span translate class="text-bold">EDIT_SUBSCRIPTION.CGM</span>&nbsp;-&nbsp;
                        <span>{{ 'EDIT_SUBSCRIPTION.CGM_TOOLTIP_1' | translate }} </span>
                    </div>
                </div>

                <div style="display: flex" *ngIf="!existsCGM && !existsSecurity && !existsAuditing && !existsVisibility">
                    <span translate>EDIT_SUBSCRIPTION.NO_ADVANCED_SETTINGS</span>
                </div>
            </div>
        </div>

        <div *ngIf="!sectionIsDisabled && productID !== 'MW'">
            <mat-divider></mat-divider>
            <div class="flex-column width-100 mt-2">
                <p class="titleTabContent" style="justify-content: flex-start" translate>{{ advancedSettingsUpdateTitle }}</p>

                <div [innerHtml]="advancedSettingsUpdateSubTitle"></div>

                <div class="message-box info mt-2" [innerHtml]="textExistingCalendar" *ngIf="showTextExistingCalendar"></div>

                <mat-radio-group [(ngModel)]="timeSlotChoice" class="flex-column" style="margin: 2rem">
                    <mat-radio-button
                        *ngFor="let timeSlot of timeSlots; index as i"
                        (change)="onValueChange(i)"
                        [value]="timeSlot.timeslotstart"
                    >
                        {{ timeSlot.timeslotstart }} - {{ timeSlot.timeslotend }}
                    </mat-radio-button>
                </mat-radio-group>

                <div class="flex-row align-center" *ngIf="!showNoteInput && copyOfNote">
                    <div class="titleTabContent">{{ copyOfNote }}</div>
                    <button
                        mat-button
                        color="primary"
                        matTooltip="{{ 'L_ADV_CONFIG_EDIT_NOTE_TOOLTIP' | translate }}"
                        matTooltipClass="tooltip-layout"
                        (click)="onEditNote()"
                    >
                        <mat-icon>edit</mat-icon>
                    </button>
                </div>

                <mat-form-field appearance="outline" class="mff-main-data" *ngIf="showNoteInput || !copyOfNote">
                    <mat-label translate>EDIT_ACCOUNTS.IPT_FLD_6</mat-label>
                    <input matInput [formControl]="noteControl" name="Note" #noteInput />
                </mat-form-field>
            </div>
        </div>
    </mat-card-content>
    <mat-card-actions
        style="display: flex; justify-content: right"
        *ngIf="(productID != 'MW' && showAdvancedSettings) || !sectionIsDisabled || showEmailSection"
    >
        <button mat-flat-button color="primary" [disabled]="disableCancelButton" (click)="restore()">
            <span translate>B_CANCEL</span>
        </button>
        <button mat-flat-button color="primary" [disabled]="disableSaveButton" (click)="save()">
            <span translate>B_SAVE</span>
        </button>
    </mat-card-actions>
</mat-card>
